import { render, staticRenderFns } from "./superfluous.vue?vue&type=template&id=a5a9316e&scoped=true&"
import script from "./superfluous.vue?vue&type=script&lang=js&"
export * from "./superfluous.vue?vue&type=script&lang=js&"
import style0 from "./superfluous.vue?vue&type=style&index=0&id=a5a9316e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a9316e",
  null
  
)

export default component.exports